<script>
import SettingsColors from './settings-colors';

export default {
    name: 'settings-brand-colors',
    extends: SettingsColors,

    data() {
        return {
            title: 'Brand Colors',
            colorCategory: 'brand',
        };
    },
};
</script>
